export default {"src":"/_next/static/media/Ref_missing_perms.0471707f.svg","height":334,"width":300,"blurWidth":0,"blurHeight":0};